import React from 'react'
import { DemoCTAProps } from '@toasttab/shared/src/data/HeaderNavigation/MainNavigationMenu'

const DemoCTA = ({
  showTablet,
  demoUrl,
  loginUrl,
  restaurantUrl,
  siteRegion
}: DemoCTAProps) => {
  const rxHeapClass = `${siteRegion}_topnav_restaurants`
  const demoHeapClass = `${siteRegion}_topnav_demo`
  const loginHeapClass = `${siteRegion}_topnav_login`

  return (
    <div
      className={`block ${
        !showTablet && 'md:!hidden'
      } min-h-[112px] py-8 md:absolute md:bottom-0 md:w-full`}
    >
      <div className='flex justify-center px-4'>
        <a
          className={`${demoHeapClass} w-full appearance-none leading-none inline-flex items-center relative transition-all duration-300 box-border justify-center text-center font-sansPro leaeding-none text-white bg-blue-75 rounded-lg border-blue-75 border-2 hover:bg-blue-100 hover:border-blue-100 cursor-pointer py-3 px-6 text-base font-semibold`}
          href={demoUrl}
        >
          Get a Demo
        </a>
      </div>

      <div className='flex justify-center px-4'>
        {siteRegion === 'us' && (
          <>
            <a
              className={`${rxHeapClass} font-sansPro text-base font-semibold text-blue-75 px-10 py-5 before:h-6 before:w-6 before:content-icon-blue-map-marker before:mr-2`}
              href={restaurantUrl}
            >
              Restaurants
            </a>
            <span className='mx-3 font-semibold text-blue-75 py-5'>|</span>
          </>
        )}
        <a
          className={`${loginHeapClass} font-sansPro text-base font-semibold text-blue-75 px-10 py-5`}
          href={loginUrl}
        >
          Login
        </a>
      </div>
    </div>
  )
}

export default DemoCTA
